import { DataWorker } from '@/workers/data.worker';
import { IServiceOptions, ServiceFactory, ServiceMode, SystemError } from '@posx/core';
import secureStorage from './secure.storage.utils';

export class ServicesBuilder {
  private static instance: ServiceFactory | null;
  public constructor() {}
  public static getInstance(): ServiceFactory {
    if (!this.instance) {
      throw new Error('ServicesBuilder has not been initialized. Call initCoreServices first.');
    }
    return this.instance;
  }

  public static async deleteInstance(): Promise<void> {
    if (this.instance) {
      this.instance = null;
    }
  }

  private static getServiceOptions(): IServiceOptions {
    const serviceFactoryOptions = {
      mode: ServiceMode.CLOUD,
      base_url: import.meta.env.VITE_BASE_URL,
      device_uid: secureStorage.getItem('device_uid') as string,
      merchant_uid: secureStorage.getItem('merchant_uid') as string,
      token: secureStorage.getAccessToken(),
      database: {
        name: 'xpos',
        version: 1,
      },
    };
    return serviceFactoryOptions;
  }

  public static initCoreServices(): void {
    if (!localStorage.getItem('cap_sec_token_response')) throw new SystemError('No token found');
    if (!secureStorage.getItem('merchant_uid')) throw new SystemError('No merchant uid found');
    ServicesBuilder.instance = new ServiceFactory(this.getServiceOptions(), window);
  }

  public static async initSignalR(): Promise<void> {
    if (!localStorage.getItem('cap_sec_token_response')) return;
    if (!secureStorage.getItem('merchant_uid')) return;
    await DataWorker.getInstance().createOrUpdateConnection(this.getServiceOptions());
  }
}
